import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import type { WebchatApiParams, WebchatApiResponse } from './web-chat-api.type';

export function useWebChatAPI({ url, code }: WebchatApiParams) {
  return useQuery({
    queryKey: ['webchat', url],
    queryFn: async () => {
      if (!url) return null;
      const { data } = await axios.get<WebchatApiResponse>(url, {
        params: code ? { pCode: code } : {},
      });
      return data as WebchatApiResponse;
    },
    enabled: !!url,
  });
}
